import { ApiResponseMovie } from '@/models/apiResponses/movie'
import { ApiResponseNotificationBoard } from '@/models/apiResponses/notifications'
import { ApiResponseStudentStudyContent } from '@/models/apiResponses/studentStudyContents'
import { ApiResponseDrillStart } from '@/models/apiResponses/drill'
import { ApiResponseExampleStudyContentInfo } from '@/models/apiResponses/studyContents'
import { ApiResponseCurriculumSUnit } from '@/models/apiResponses/curriculumSUnits'
import { NotificationItem } from '@/models/notificationModel'
import { StudyItemListType } from '@/models/studyListModel'
import { SUnitCategorySetting } from '@/const/ApiSettings'

export class StudySelectionUtils {
  /**
   * お知らせ掲示一覧を表示用に変換する
   * @param apiResponse API受信した値
   * @returns お知らせ掲示一覧
   */
  public static formatNotifications(apiResponse: ApiResponseNotificationBoard[] | null): NotificationItem[] {
    if (!apiResponse) return []

    return apiResponse
  }

  /**
   * テスト一覧を表示用に変換する
   * @param apiResponse API受信した値
   * @returns テスト一覧
   */
  public static formatStudyList(apiResponse: ApiResponseStudentStudyContent[] | null): StudyItemListType[] | null {
    if (!apiResponse) return null

    const studyList: StudyItemListType[] = apiResponse.map((studentStudyContent) => {
      return {
        title: studentStudyContent.name,
        items: Object.entries(studentStudyContent.curriculumSUnits).map(([, curriculumSUnit]) => {
          return {
            subjectName: curriculumSUnit.subjectName,
            sUnitName: curriculumSUnit.curriculumName,
            lastMinuteCheckSUnitId: Number(curriculumSUnit.ids[0][0]),
            isLastMinuteCheckLearned: Boolean(curriculumSUnit.ids[0][1]),
            isResolveCsvExist: Boolean(curriculumSUnit.paperTest),
            resolveSUnitId: Number(curriculumSUnit.ids[1][0]),
            isResolveLearned: Boolean(curriculumSUnit.ids[1][1]),
          }
        }),
      }
    })

    return studyList
  }

  /**
   * 解き方動画URLを取得する
   * @param apiResponse API受信した値
   * @returns 解き方動画URL
   */
  public static getMovieUrl(apiResponse: ApiResponseMovie | null): string {
    if (!apiResponse) return ''

    return apiResponse.url
  }

  /**
   * 学習ドリル開始時の結果ドリルIDを取得する
   * @param apiResponse API受信した値
   * @returns 結果ドリルID
   */
  public static getStartResultDrillId(
    apiResponse: ApiResponseDrillStart | null
  ): ApiResponseDrillStart['resultDrillId'] | null {
    if (!apiResponse) return null

    return apiResponse.resultDrillId
  }

  /**
   * サンプルテストコンテンツの小項目IDを取得する
   * @param apiResponse API受信した値
   * @returns 小項目ID
   */
  public static getExampleSUnitId(apiResponse: ApiResponseExampleStudyContentInfo | null): number | null {
    if (!apiResponse) return null

    return apiResponse.sUnitId
  }

  /**
   * 小項目のカテゴリーを取得する
   * @param apiResponse API受信した値
   * @returns カテゴリー
   */
  public static getSUnitCategory(apiResponse: ApiResponseCurriculumSUnit): SUnitCategorySetting | null {
    if (!apiResponse) return null

    return apiResponse.category
  }

  /**
   * 小項目の学習名を取得する
   * @param apiResponse API受信した値
   * @returns 学習名
   */
  public static getSUnitStudyName(apiResponse: ApiResponseCurriculumSUnit): string {
    if (!apiResponse) return ''

    return apiResponse.studyName
  }
}
